import { render } from "./ServiceQueue.vue?vue&type=template&id=7f6099dc&scoped=true"
import script from "./ServiceQueue.vue?vue&type=script&lang=js"
export * from "./ServiceQueue.vue?vue&type=script&lang=js"

import "./ServiceQueue.vue?vue&type=style&index=0&id=7f6099dc&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6099dc"]])

export default __exports__